import React from 'react';
import './MessageSectionInspector.css';

function MessageSectionInspector({ 
  func, 
  index, 
  onUpdate, 
  hideIconBool = false, 
  hideTitleBool = false,
  isIconPickerOpen,
  setIsIconPickerOpen,
  iconPickerPosition,
  setIconPickerPosition,
  setActiveIconPreview,
  bringToFront
}) {
  const handleChange = (key, value) => {
    const newProps = {
      ...func.props,
      [key]: value
    };
    onUpdate(index, newProps);
  };

  const handleIconChange = (field, value) => {
    console.log('handleIconChange called with:', { field, value });
    console.log('Current icon state:', func.props.icon);
    
    if (field === 'icon') {
      // If we're setting the entire icon object
      console.log('Setting entire icon object:', value);
      handleChange('icon', value);
    } else {
      // If we're updating a single field
      const newIcon = {
        ...(func.props.icon || {}),
        [field]: value
      };
      console.log('Setting single field. New icon state:', newIcon);
      handleChange('icon', newIcon);
    }
  };

  const handleParagraphChange = (paragraphIndex, value) => {
    const newParagraphs = [...(func.props.paragraphs || [])];
    newParagraphs[paragraphIndex] = value;
    handleChange('paragraphs', newParagraphs);
  };

  const addParagraph = () => {
    const newParagraphs = [...(func.props.paragraphs || []), ''];
    handleChange('paragraphs', newParagraphs);
  };

  const removeParagraph = (paragraphIndex) => {
    const newParagraphs = func.props.paragraphs.filter((_, idx) => idx !== paragraphIndex);
    handleChange('paragraphs', newParagraphs);
  };

  const handleButtonChange = (buttonIndex, field, value) => {
    const newButtons = [...(func.props.buttons || [])];
    newButtons[buttonIndex] = {
      ...newButtons[buttonIndex],
      [field]: value
    };
    handleChange('buttons', newButtons);
  };

  const addButton = () => {
    const newButtons = [...(func.props.buttons || []), { name: '', url: '' }];
    handleChange('buttons', newButtons);
  };

  const removeButton = (buttonIndex) => {
    const newButtons = func.props.buttons.filter((_, idx) => idx !== buttonIndex);
    handleChange('buttons', newButtons);
  };

  return (
    <div className="message-section-inspector">
      {!hideIconBool && (
        <div className="icon-section">
          <div className="icon-inputs">
            <div className="input-group">
              <label>ViewBox</label>
              <input
                type="text"
                value={func.props.icon?.viewBox || ''}
                onChange={(e) => handleIconChange('viewBox', e.target.value)}
                placeholder="e.g. 0 0 512 512"
                className="full-width-input"
              />
            </div>
            <div className="input-group">
              <label>SVG Path</label>
              <input
                type="text"
                value={func.props.icon?.svg_path || ''}
                onChange={(e) => handleIconChange('svg_path', e.target.value)}
                placeholder="SVG path data"
                className="full-width-input"
              />
            </div>
          </div>
          {/* {func.props.icon?.viewBox && func.props.icon?.svg_path && ( */}
            <div 
              className="icon-preview"
              onClick={(e) => {
                console.log('Icon preview clicked');
                // Only set initial position if we don't have any position saved
                // Don't set position on first click anymore since we have a default position
                if (false) {
                  // Calculate centered position on the right side
                  const windowHeight = window.innerHeight;
                  const modalHeight = 600; // Approximate height of the modal
                  const rightGap = 20; // Gap from the right edge
                  const newPosition = {
                    x: window.innerWidth - 500 - rightGap, // 500 is the modal width
                    y: (windowHeight - modalHeight) / 2 // Center vertically
                  };
                  
                  console.log('Setting initial position:', newPosition);
                  setIconPickerPosition(newPosition);
                }
                // Only store the index - no handler function
                setActiveIconPreview({ index });
                setIsIconPickerOpen(true);
                bringToFront('iconPicker');
                e.stopPropagation(); // Prevent event bubbling
              }}
              title="Click to change icon"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox={func.props.icon?.viewBox}
                style={{ verticalAlign: 'middle' }}
                className="preview-svg"
              >
                <path 
                  d={func.props.icon?.svg_path}
                  style={{
                    // Default: fill none, stroke icon-color
                    // Fill on: both fill and stroke icon-color
                    // Fill + Highlight: stroke highlight-color, fill icon-color
                    fill: func.props.icon?.fill === "true" ? (
                      func.props.icon?.useHighlight === "true" ? 'var(--icon-color)' : 'var(--icon-color)'
                    ) : 'none',
                    stroke: func.props.icon?.fill === "true" && func.props.icon?.useHighlight === "true" 
                      ? 'var(--highlight-color)' 
                      : 'var(--icon-color)'
                  }}
                />
              </svg>
            </div>

            <div className="msg-inspector-toggles">
              <div className="msg-inspector-toggle-group">
                <div className="msg-inspector-toggle-row">
                  Fill Vector Graphic
                  <div className="msg-inspector-switch">
                    <input
                      type="checkbox"
                      checked={func.props.icon?.fill === "true"}
                      onChange={(e) => {
                        const newValue = e.target.checked;
                        handleIconChange('fill', newValue ? "true" : "false");
                        // Reset useHighlight to false when fill is turned off
                        if (!newValue && func.props.icon?.useHighlight === "true") {
                          handleIconChange('useHighlight', "false");
                        }
                      }}
                    />
                    <span className="msg-inspector-slider" onClick={(e) => {
                      const newValue = func.props.icon?.fill !== "true";
                      handleIconChange('fill', newValue ? "true" : "false");
                      // Reset useHighlight to false when fill is turned off
                      if (!newValue && func.props.icon?.useHighlight === "true") {
                        handleIconChange('useHighlight', "false");
                      }
                    }}></span>
                  </div>
                </div>
              </div>

              <div className="msg-inspector-toggle-group">
                <div className="msg-inspector-toggle-row">
                  Highlight to Outline
                  <div className="msg-inspector-switch">
                    <input
                      type="checkbox"
                      checked={func.props.icon?.useHighlight === "true"}
                      disabled={func.props.icon?.fill !== "true"}
                      onChange={(e) => handleIconChange('useHighlight', e.target.checked ? "true" : "false")}
                    />
                    <span 
                      className={`msg-inspector-slider ${func.props.icon?.fill !== "true" ? 'msg-inspector-disabled' : ''}`}
                      onClick={(e) => {
                        if (func.props.icon?.fill === "true") {
                          const newValue = func.props.icon?.useHighlight !== "true";
                          handleIconChange('useHighlight', newValue ? "true" : "false");
                        }
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>

          {/* )} */}
        </div>
      )}

      {!hideTitleBool && (
        <div className="input-group">
          <label>Header</label>
          <input
            type="text"
            value={func.props.header || ''}
            onChange={(e) => handleChange('header', e.target.value)}
            placeholder="Section header"
            className="full-width-input"
          />
        </div>
      )}

      <div className="paragraphs-section">
        <h4>Paragraphs</h4>
        {(func.props.paragraphs || []).map((paragraph, idx) => (
          <div key={idx} className="paragraph-item">
            <textarea
              value={paragraph}
              onChange={(e) => handleParagraphChange(idx, e.target.value)}
              placeholder="Enter paragraph text"
              className="paragraph-input"
              rows={2}
            />
            <button
              onClick={() => removeParagraph(idx)}
              className="remove-button"
              title="Remove paragraph"
            >
              ×
            </button>
          </div>
        ))}
        <button
          onClick={addParagraph}
          className="add-button"
        >
          + Add Paragraph
        </button>
      </div>

      <div className="button-section">
        <div className="msg-inspector-toggle-group">
          <div className="msg-inspector-toggle-row">
            <h4>Action Buttons</h4>
            <div className="msg-inspector-switch">
              <input
                type="checkbox"
                checked={func.props.showButtons === true || func.props.showButtons === "true"}
                onChange={(e) => {
                  const showButtons = e.target.checked;
                  handleChange('showButtons', showButtons);
                  if (!func.props.buttons || func.props.buttons.length === 0) {
                    handleChange('buttons', [{ name: '', url: '' }]);
                  }
                }}
              />
              <span className="msg-inspector-slider" onClick={(e) => {
                const showButtons = !(func.props.showButtons === true || func.props.showButtons === "true");
                handleChange('showButtons', showButtons);
                if (!func.props.buttons || func.props.buttons.length === 0) {
                  handleChange('buttons', [{ name: '', url: '' }]);
                }
              }}></span>
            </div>
          </div>
        </div>

        {(func.props.showButtons === true || func.props.showButtons === "true") && (
          <div className="buttons-section">
            {(func.props.buttons || []).map((button, idx) => (
              <div key={idx} className="button-item">
                <div className="button-inputs">
                  <div className="input-group">
                    <label>Button Name</label>
                    <input
                      type="text"
                      value={button.name || ''}
                      onChange={(e) => handleButtonChange(idx, 'name', e.target.value)}
                      placeholder="Enter button text"
                      className="full-width-input"
                    />
                  </div>
                  <div className="input-group">
                    <label>Button URL</label>
                    <input
                      type="text"
                      value={button.url || ''}
                      onChange={(e) => handleButtonChange(idx, 'url', e.target.value)}
                      placeholder="Enter button URL"
                      className="full-width-input"
                    />
                  </div>
                </div>
                {idx > 0 && (
                  <button
                    onClick={() => removeButton(idx)}
                    className="remove-button"
                    title="Remove button"
                  >
                    ×
                  </button>
                )}
              </div>
            ))}
            <button
              onClick={addButton}
              className="add-button"
            >
              + Add Button
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default MessageSectionInspector;
